import request from '@/utils/ajax'


export function saveWechatConfig(data) {
    return request({
        url: '/wx/manage/qywxBotConfig/save',
        method: 'post',
        data: data
    })
}

export function editWechatConfig(data) {
    return request({
        url: '/wx/manage/qywxBotConfig/update',
        method: 'put',
        data: data
    })
}

export function deleteWechatConfig(data) {
    return request({
        url: '/wx/manage/qywxBotConfig/delete',
        method: 'post',
        data: data
    })
}
